export enum NotificationsAction {
  // toasts
  AddToast = 'addToast',
  RemoveToast = 'removeToast',
  ClearToasts = 'clearToasts',
  // dialogs
  ShowSmallDialog = 'showSmallDialog',
  SetSmallDialogIsLoading = 'setSmallDialogIsLoading',
  HideSmallDialog = 'hideSmallDialog',
  UpdateAcceptButtonLabel = 'updateAcceptButtonLabel',
}
